import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'secondsToMinutes',
    standalone: true,
})
export class SecondsToMinutesPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        const minutes = Math.floor(value/60);
        const seconds = Math.floor(value%60);
        return `${("0"+minutes).slice(-2)}:${("0"+seconds).slice(-2)}`
    }
}
